import { useEffect, useState } from 'react';
import appConstants from '../../../../constants';
import fetchLoggedInUser from '../../../../services/fetchLoggedInUser';
import UserModel from '../../../../models/userModel';
import setLocalStorageItem from "../../../../utils/setLocalStorageItem";

const defaults = Object.freeze({
  isLoggedInUserFetchingInProgress: false,
  loggedInUserFetchingError: null,
  user: new UserModel()
});

export default function useUser() {
  const [isLoggedInUserFetchingInProgress, setIsLoggedInUserFetchingInProgress] = useState(defaults.isLoggedInUserFetchingInProgress);
  const [loggedInUserFetchingError, setLoggedInUserFetchingError] = useState(defaults.loggedInUserFetchingError);
  const [user, setUser] = useState(defaults.user);

  useEffect(
    () => {
      async function fetchUser() {
        const fetchedUser = await fetchLoggedInUser();
        if(!fetchedUser.hasError) {
          setUser(fetchedUser.user);
          setLoggedInUserFetchingError(null);
          setLocalStorageItem(appConstants.LOCALSTORAGE_KEY_LOGGED_IN_USER, fetchedUser.user.isLoggedIn());
        }
        else {
          setUser(defaults.user);
          setLoggedInUserFetchingError(fetchedUser.statusMessage);
        }
        setIsLoggedInUserFetchingInProgress(false);
      }
      setIsLoggedInUserFetchingInProgress(true);
      fetchUser();
    },
    []
  );

  return {
    user,
    isLoggedInUserFetchingInProgress,
    loggedInUserFetchingError
  }
}
